<template>
  <div class="h-96 lg:h-64 xl:h-96">
    <canvas id="line-chart-day"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";
import lineChartDay from "./line-chart-data";

export default {
  name: "LineChartDay",

  data() {
    return {
      lineChartDay,
    };
  },
  mounted() {
    const ctx = document.getElementById("line-chart-day");
    new Chart(ctx, this.lineChartDay);
  },
};
</script>
